import {
  Card,
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Switch,
  Button,
  alpha,
  IconButton,
} from "@mui/material";
import GoTableHead from "./GoTableHead";
import GoTableSearch from "./GoTableSearch";
import GoSwitch from "../../components/Inputs/GoSwitch";
import { useEffect, useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import Iconify from "../../components/iconify/Iconify";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

const myfilter = {
  max: 10,
  offset: 0,
  order: "asc",
  search: "",
  sort: "id",
};

const GoTable = ({
  tableHeads,
  tableDatas,
  totalCount = 0,
  onFilter,
  filter = myfilter,
  onView,
  onDo,
  search = true,
  pagination = true,
  onSwitch = () => {},
  onAction = () => {},
  customFilter = false,
  openFilter = () => {},
}) => {
  const [tableFilter, setTableFilter] = useState(filter);

  // useEffect(() => {
  //   if (filter) {
  //     setTableFilter(filter);
  //   }
  // }, []);

  useEffect(() => {
    if (onFilter) {
      onFilter(tableFilter);
    }
  }, [tableFilter]);

  const [selected, setSelected] = useState([]);

  const handleRequestSort = (event, property) => {
    const isAsc = tableFilter.sort === property && tableFilter.order === "asc";
    setTableFilter((prevState) => {
      return { ...prevState, sort: property, order: isAsc ? "desc" : "asc" };
    });
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = tableDatas.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setTableFilter((prevState) => {
      return { ...prevState, offset: newPage };
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setTableFilter((prevState) => {
      return { ...prevState, offset: 0, max: parseInt(event.target.value, 10) };
    });
  };

  const handleFilterByName = (event) => {
    setTableFilter((prevState) => {
      return { ...prevState, offset: 0, search: event.target.value };
    });
  };

  const booleanFilter = (name, value) => {
    if (name === "is_paid") {
      return value ? "Paid" : "Unpaid";
    }
    return value ? "Yes" : "No";
  };

  return (
    <Card>
      {search && (
        <GoTableSearch
          filterName={tableFilter.search}
          onSearch={handleFilterByName}
          customFilter={customFilter}
          openFilter={openFilter}
        />
      )}

      <TableContainer sx={{ minWidth: 800 }}>
        <Table>
          <GoTableHead
            order={tableFilter.order}
            orderBy={tableFilter.sort}
            headLabel={tableHeads}
            rowCount={tableDatas.length}
            numSelected={selected.length}
            onRequestSort={handleRequestSort}
            onSelectAllClick={handleSelectAllClick}
          />
          <TableBody>
            {tableDatas.length > 0 &&
              tableDatas.map((row, index) => {
                return (
                  <TableRow
                    hover
                    key={"row" + row.id + index}
                    tabIndex={-1}
                    role="checkbox"
                  >
                    {tableHeads.map((col) => {
                      return (
                        <TableCell
                          key={"col" + col.id + row.id}
                          align={col.align}
                        >
                          {col.type === "text" && row[col.id]}
                          {col.type === "number" && row[col.id]}
                          {col.type === "date" &&
                            row[col.id] !== null &&
                            row[col.id] !== undefined &&
                            new Date(row[col.id])
                              .toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .toString()
                              .replaceAll(" ", "-")}
                          {col.type === "switch" && (
                            <GoSwitch
                              checked={row[col.id]}
                              disabled={col.disabled}
                              onChange={() => onSwitch(row)}
                            />
                          )}
                          {col.type === "boolean" &&
                            booleanFilter(col.id, row[col.id])}
                          {/* {col.type === "boolean" &&
                            col.id === "is_paid" &&
                            row[col.id] &&
                            "Paid"}

                          {col.type === "boolean" &&
                            col.id === "is_paid" &&
                            !row[col.id] &&
                            "Unpaid"}

                          {col.type === "boolean" && row[col.id] && "Yes"}
                          {col.type === "boolean" && !row[col.id] && "No"} */}
                          {col.type === "iconbtn" && (
                            <Button
                              size="small"
                              startIcon={<Iconify icon={col.icon} />}
                              onClick={() => onDo(col.func, row)}
                            ></Button>
                          )}
                          {col.type === "edit" && (
                            <Button
                              size="small"
                              variant="contained"
                              startIcon={<EditIcon />}
                              sx={{
                                bgcolor: (theme) =>
                                  alpha(theme.palette.success.dark, 1),
                              }}
                              onClick={() => onView(row)}
                            >
                              Edit
                            </Button>
                          )}
                          {col.type === "view" && (
                            <Button
                              size="small"
                              variant="contained"
                              startIcon={<RemoveRedEyeOutlinedIcon />}
                              sx={{
                                bgcolor: (theme) =>
                                  alpha(theme.palette.success.dark, 1),
                              }}
                              onClick={() => onView(row)}
                            >
                              View
                            </Button>
                          )}
                          {col.type === "download_btn" && (
                            <Button
                              size="small"
                              variant="contained"
                              startIcon={<DownloadIcon />}
                              sx={{
                                bgcolor: (theme) =>
                                  alpha(theme.palette.success.dark, 1),
                              }}
                              onClick={() => onView(row)}
                            >
                              Download
                            </Button>
                          )}

                          {col.type === "icon_btns" && !row.row_type && (
                            <div>
                              {col.buttons.indexOf("edit") > -1 && (
                                <IconButton
                                  aria-label="edit"
                                  size="small"
                                  onClick={() => onAction(row, "edit")}
                                >
                                  <EditIcon fontSize="small" color="success" />
                                </IconButton>
                              )}
                              {col.buttons.indexOf("delete") > -1 && (
                                <IconButton
                                  aria-label="delete"
                                  size="small"
                                  onClick={() => onAction(row, "delete")}
                                >
                                  <DeleteIcon fontSize="small" color="error" />
                                </IconButton>
                              )}
                            </div>
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
          {tableDatas.length === 0 && (
            <TableBody>
              <TableRow>
                <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                  <Paper
                    sx={{
                      textAlign: "center",
                    }}
                  >
                    <Typography variant="h6" paragraph>
                      Not found
                    </Typography>

                    <Typography variant="body2">
                      No results found for &nbsp;
                      <strong>&quot;{tableFilter.search}&quot;</strong>.
                      <br /> Try checking for typos or using complete words.
                    </Typography>
                  </Paper>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {pagination && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalCount}
          rowsPerPage={tableFilter.max}
          page={tableFilter.offset}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </Card>
  );
};

export default GoTable;
